import React from "react"
import ReactDOM from "react-dom"
import DesignElementCardContainerBlockComponent from "./design-element-card-container-block-component"

export default class DesignElementCardContainerBlockModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.locale = (document.body && document.body.dataset.language) || "da"
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(
      <DesignElementCardContainerBlockComponent
        backgroundColor={self.modelJson.backgroundColor}
        bottomPadding={self.modelJson.bottomPadding}
        topPadding={self.modelJson.topPadding}
        header={self.modelJson.header}
        designCards={self.modelJson.designCards}
        clipBoardText={self.modelJson.clipBoardText}
        clipBoardCopiedText={self.modelJson.clipBoardCopiedText}
        enableCarousel={self.modelJson.enableCarousel}
        enableClipboard={self.modelJson.enableClipboard}
        locale={self.locale}
      />,
      self.elem,
    )
  }
}
